import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
	state: {
		menu: { // 菜单相关的
			isCollapse: false
		},
		oaAppId: null,
		localId: null,
		isLogin: false,
		token: null,
		tenantId: null,
		appId: null,
		appType: null,
		error: null,
		userId: null,
		isWxEnv: false,
		isMobile: false, // true: 移动端, false: PC端
		corpId: null,
		managerId: null, // 星河管理员 ID
		agentId: null,
		contactId: null,
		context: {
			entry: null, // 返回进入H5页面的入口类型，目前有normal、contact_profile、single_chat_tools、group_chat_tools、chat_attachment
			shareTicket: null // 可用于调用getShareInfo接口
		},
		externalUserInfo: { // 外部联系人信息，仅单聊场景会有值
			externalUserId: null, // 外部联系人ID
			memberId: null, // 星河学员ID
			unionId: null,
			headUrl: null, // 星河学员头像
			nickName: null, // 星河学员昵称
			remark: null, // 备注
			tel: null, // 加密手机号
			decodeTel: null, // 未加密手机号
			addTime: null // 添加时间
		},
		isCollapse: false
	},
	mutations: {
		update(o, n) {
			for (var key in n) {
				o[key] = n[key]
			}
		}
	},
	actions: {
	}
})



// WEBPACK FOOTER //
// ./src/store/index.js